<template>
  <v-card outlined :loading="loading">
    <v-card-title
      class="d-flex justify-space-between pb-0"
      v-intersect="onIntersect"
    >
      <h6 class="lh-1">Pagamentos por Canal</h6>
      <v-btn-toggle mandatory v-model="display" class="ml-2">
        <v-btn small> R$ </v-btn>
        <v-btn small> Qtde </v-btn>
      </v-btn-toggle>
    </v-card-title>
    <v-card-text>
      <v-alert
        type="warning"
        dense
        class="mb-0"
        v-if="!chartSeries.length"
        outlined
      >
        Nenhum pagamento válido.
      </v-alert>

      <apexCharts
        v-else
        type="donut"
        height="250"
        :options="chartOptions"
        :series="chartSeries"
      />
      <v-alert v-if="error" type="error" class="mb-0">
        {{ error }}
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import ApexCharts from "vue-apexcharts";

export default {
  components: {
    ApexCharts,
  },
  data: () => ({
    error: null,
    display: 0,
    viewed: false,
    isIntersecting: false,
    channelColors: {
      pos: "#FF4560",
      ticketOffice: "#775DD0",
      shop: "#008FFB",
      seller: "#00E396",
      unknown: "#000",
    },
    channelTranslation: {
      pos: "PDV",
      ticketOffice: "Bilheteria",
      shop: "Site",
      seller: "Promoter",
      unknown: "Externo",
    },
  }),
  methods: {
    onIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.isIntersecting = true;
        this.viewed = true;
      } else {
        this.isIntersecting = false;
      }
    },
  },
  computed: {
    paymentTypes() {
      if (!this.viewed) return {};
      return this.data.payments
        .filter((payment) => payment.status == "succeeded")
        .reduce((acc, p) => {
          var channel = "shop";
          if (p.paymentMethod == "OFFLINE" && p.paymentType == "UNKNOWN") {
            channel = "unknown";
          } else if (p.PosSession || p.paymentMethod == "POS") {
            channel = "pos";
            if (p.PosSession?.partyId) channel = "ticketOffice";
          } else if (p.Ticket.some((t) => t.Seller)) {
            channel = "seller";
          }

          if (!acc[channel]) {
            acc[channel] = 0;
          }
          acc[channel] += this.display
            ? 1
            : p.Ticket.reduce(
                (acc, { amount, platformFee }) => acc + amount - platformFee,
                0
              );

          return acc;
        }, {});
    },
    chartSeries() {
      if (!this.paymentTypes) return [];
      return Object.values(this.paymentTypes);
    },
    chartOptions() {
      const channelTranslation = this.channelTranslation;
      return {
        chart: {
          type: "donut",
          height: 250,
        },
        legend: {
          show: true,
          position: "bottom",
          formatter: (seriesName, opts) => {
            var value = opts.w.globals.series[opts.seriesIndex];
            value = this.display
              ? `${value} venda${value != 1 ? "s" : ""}`
              : value.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                });
            return `${seriesName}: ${value}`;
          },
        },
        labels: Object.keys(this.paymentTypes).map(
          (key) => channelTranslation[key] || key
        ),
        colors: Object.keys(this.paymentTypes).map(
          (key) => this.channelColors[key] || key
        ),
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          labels: {
            formatter: (value) =>
              this.display
                ? `${value} venda${value != 1 ? "s" : ""}`
                : value.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }),
          },
        },
      };
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style></style>
